<template>
  <div>
    <dx-description-label v-if="$te(`${translationKeyPrefix}.description`)">
      {{ $t(`${translationKeyPrefix}.description`) }}
    </dx-description-label>

    <template v-if="hasToggle">
      <label class="label" :for="config.id">{{ translatedLabel }}</label>
      <button class="toggleButton" type="button" @click="toggleTextArea">
        <chevron-down-icon :class="['icon', !isOpen && 'iconTurned']" />
        <span>{{ this.$t(`${translationKeyPrefix}.toggle`) }}</span>
      </button>

      <dx-textarea
        v-if="isOpen"
        :id="config.id"
        :value="value"
        :disabled="config.readonly"
        :error="translatedError"
        @input="update"
        @blur="onBlur"
      />
    </template>

    <template v-else>
      <dx-textarea
        :id="config.id"
        :value="value"
        :label="translatedLabel"
        :disabled="config.readonly"
        :error="translatedError"
        @input="update"
        @blur="onBlur"
      />
    </template>
  </div>
</template>

<script>
import {
  DxDescriptionLabel,
  DxTextarea,
} from '@sumcumo/dextra-frontend-component-lib'
import ChevronDownIcon from '~/components/icons/ChevronDownIcon'

export default {
  name: 'DXTextAreaAdapter',
  components: {
    ChevronDownIcon,
    DxTextarea,
    DxDescriptionLabel,
  },

  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: [Number, String],
      default: null,
    },
    error: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isOpen: false,
    }
  },

  computed: {
    translationKeyPrefix() {
      if (this.config.source) {
        if (this.config.source.kind === 'values') {
          return `attributes.${this.config.source.key}.${this.config.source.originalId}`
        }

        return `${this.config.source.key}.${this.config.source.originalId}`
      }

      return ''
    },

    translatedLabel() {
      return this.$t(`${this.translationKeyPrefix}.label`)
    },

    translatedError() {
      return this.error
        ? this.$t(`errors.text.${this.error.type}`, {
            ...this.error.params,
            label: this.translatedLabel,
          })
        : null
    },

    hasToggle() {
      return this.config.source.originalId === 'extra-details'
    },
  },

  methods: {
    update(newValue) {
      this.$emit('input', newValue)
    },

    toggleTextArea() {
      this.isOpen = !this.isOpen
    },

    onBlur() {
      this.$emit('validate', this.config.id)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/colors';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/typo';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/functions/px-to-rem';
.label {
  margin-bottom: rem(8);
  color: $black-clr;
  font-family: $font-family-heavy;
  font-size: rem(20);
  line-height: rem(28);
}

.toggleButton {
  display: flex;
  margin-bottom: rem(16);
  border: none;
  padding: 0;
  background: transparent;
  font-family: $font-family-heavy;
  font-size: rem(16);
  line-height: rem(24);
  outline: none;
}

.icon {
  margin-right: rem(16);
  color: $functional-clr-info;
  transition: transform 200ms ease-in-out;
}

.iconTurned {
  transform: rotate(180deg);
}
</style>
